import ApiService from './api.service'

const CampaignService = {
    /**
     * Get campaign by hash with user data appended
     * @param {string} hash - Campaign hash
     * @returns {Promise<Object>} Campaign data with user info
     */
    getCampaignByHash: async function(hash) {
        const response = await ApiService.get(`campaign/${hash}/hash?appendUser=1&appendItems=1&appendAllocations=1`);
        return response.data.data;
    },

    /**
     * Create a payment intent for a campaign donation
     * @param {string} hash - Campaign hash
     * @param {Object} data - Payment data { amount, paymentFee }
     * @returns {Promise<Object>} Payment intent with clientSecret
     */
    createPaymentIntent: async function(hash, data) {
        const response = await ApiService.post(`campaign/${hash}/create-payment-intent`, data);
        return response.data.data;
    },

    /**
     * Store a donation record with optional allocations
     * @param {Object} donation - Donation data
     * @param {Array} allocations - Optional array of { campaign_item_id, amount } allocations
     * @returns {Promise<Object>} Stored donation
     */
    storeDonation: async function(donation, allocations = []) {
        const payload = { donation };
        if (allocations && allocations.length > 0) {
            payload.allocations = allocations;
        }
        const response = await ApiService.post('donation', payload);
        return response.data.data;
    },

    /**
     * Get available campaign item categories
     * @returns {Promise<Array>} Array of category objects
     */
    getCampaignItemCategories: async function() {
        const response = await ApiService.get('campaign-item-categories');
        return response.data.data;
    }
}

export default CampaignService

export { CampaignService }
